var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Just, Nothing } from 'purify-ts/Maybe';
import client from '@/client';
import { AutoTestStore } from '@/store/modules/autotest';
import * as utils from '@/utils';
import { CacheDecorator } from '@/utils/cache';
import { AutoTestSuite } from './suite';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class AutoTestSet {
    id;
    stopPoints;
    autoTestId;
    setIndex;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _cache = new CacheDecorator();
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    suites;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, suites, stopPoints, autoTestId, setIndex) {
        this.id = id;
        this.stopPoints = stopPoints;
        this.autoTestId = autoTestId;
        this.setIndex = setIndex;
        this.suites = Object.freeze(suites.map(d => {
            if (d instanceof AutoTestSuite) {
                return d;
            }
            return AutoTestSuite.fromServerData(d, this);
        }));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    update(data) {
        return new AutoTestSet(this.id, this.suites, data.stopPoints ?? this.stopPoints, this.autoTestId, data.setIndex ?? this.setIndex);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data, setIndex, testId) {
        return new AutoTestSet(data.id, data.suites, data.stopPoints, testId, setIndex);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get pointsPossible() {
        return utils.sumMap(this.suites, utils.attr('pointsPossible'));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getPreviousSet() {
        if (this.setIndex === 0) {
            return Nothing;
        }
        return Just(this.autoTest.sets[this.setIndex - 1]);
    }
    get steps() {
        return utils.flat1(this.suites.map(suite => suite.steps));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get autoTest() {
        return AutoTestStore.getTest()(this.autoTestId).unsafeCoerce();
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    equals(other) {
        return this.id === other.id;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    save() {
        return client.autoTest.updateSet({
            autoTestId: this.autoTestId,
            autoTestSetId: this.id,
            requestBody: {
                stopPoints: this.stopPoints,
            },
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    delete() {
        return client.autoTest.deleteSet({
            autoTestId: this.autoTestId,
            autoTestSetId: this.id,
        });
    }
}
__decorate([
    CacheDecorator.cache
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
], AutoTestSet.prototype, "steps", null);
